import React from "react";
import PropTypes from "prop-types";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import useIsMobile from "arena/hooks/useIsMobile";
import ShortyContentComments from "./ShortyContentComments";

const iOS =
  typeof navigator !== "undefined" &&
  /iPad|iPhone|iPod/.test(navigator.userAgent);

export default function ShortyCommentsDrawer({
  content,
  open,
  onClose,
  onOpen,
}) {
  const theme = useTheme();
  const isMobile = useIsMobile();

  if (!content?.isCommentsEnabled) return null;

  const anchor = isMobile ? "bottom" : "right";
  const drawerWidth = 400;

  const handleClose = (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    onClose();
  };

  const handleOpen = (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    onOpen();
  };

  return (
    <SwipeableDrawer
      anchor={anchor}
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      disableBackdropTransition={!iOS}
      disableDiscovery={iOS}
      disableSwipeToOpen={true}
      keepMounted={false} // Для лучшей производительности
      sx={{
        zIndex: 1400, // Выше обычных модалов
        "& .MuiDrawer-paper": {
          width: isMobile ? "100%" : drawerWidth,
          height: isMobile ? "70vh" : "100vh",
          maxHeight: isMobile ? "70vh" : "100vh",
          backgroundColor: theme.palette.background.default,
          borderTopLeftRadius: isMobile ? 16 : 0,
          borderTopRightRadius: isMobile ? 16 : 0,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: theme.palette.background.default,
          // Переопределяем только проблемные элементы
          "& .MuiAppBar-root": {
            backgroundColor: `${theme.palette.background.default} !important`,
          },
        }}
      >
        {/* Контейнер для комментариев */}
        <Box
          sx={{
            flex: 1,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <ShortyContentComments contentId={content.id} onClose={onClose} />
        </Box>
      </Box>
    </SwipeableDrawer>
  );
}

ShortyCommentsDrawer.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    isCommentsEnabled: PropTypes.bool,
  }),
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
};
